// Sensible starting values for newly added nodes. Money fields start at zero
// pence; the user fills them in via the inspector.
import { pence, type VulpariNode } from "@vulpari/core";

const TYPE_NAME: Record<VulpariNode["type"], string> = {
  account: "New Account",
  card: "New Card",
  income: "New Income",
  bill: "New Bill",
  oneoff: "New One-off",
  pot: "New Pot",
  external: "New External",
};

export function defaultName(type: VulpariNode["type"]): string {
  return TYPE_NAME[type];
}

/** Default meta for a node type. `month` (YYYY-MM) seeds a one-off's due date. */
export function defaultMeta(type: VulpariNode["type"], month: string): VulpariNode["meta"] {
  switch (type) {
    case "account":
      return { balance: pence(0), role: "spending" };
    case "card":
      return {
        kind: "credit_card",
        balance: pence(0),
        creditLimit: pence(0),
        aprBasisPoints: 0,
        minPayment: pence(0),
        statementBalance: pence(0),
        dueDay: 1,
        payment: pence(0),
      };
    case "income":
      return { amount: pence(0), payDay: 28 };
    case "bill":
      return { amount: pence(0), frequency: "monthly", dueDay: 1 };
    case "oneoff":
      return { amount: pence(0), dueDate: `${month}-01` };
    case "pot":
      return { balance: pence(0), target: pence(0), topUp: pence(0) };
    case "external":
      return { amount: pence(0) };
  }
}
